// AI generated
import type { Edge, EdgeMarker } from '@xyflow/react'
import { MarkerType } from '@xyflow/react'

export const markerVariants: { [key: string]: EdgeMarker } = {
  default: {
    type: MarkerType.ArrowClosed,
    width: 30,
    height: 30,
    color: '#000',
    strokeWidth: 0.5,
  },
}

export function extractEdgeMarkers(edge: Edge) {
  const variant = (edge.data?.markerType ??
    'default') as keyof typeof markerVariants
  const markerConfig = markerVariants[variant] ?? markerVariants.default

  return {
    ...edge,
    markerStart: edge.data?.hasMarkerStart ? markerConfig : undefined,
    markerEnd: edge.data?.hasMarkerEnd ? markerConfig : undefined,
  }
}
